/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_ABRILFATFACE_REGULAR: 'AbrilFatfaceRegular, serif',
  FONT_LATO_BOLD: 'LatoBold, sans-serif',
  FONT_LATO_REGULAR: 'LatoRegular, sans-serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_600: '600',
  FONT_WEIGHT_500: '500',
  FONT_WEIGHT_300: '300',
  //Mobile values
  //H1
  FONT_SIZE_H1: '40px',
  LINE_HEIGHT_H1: '46px',
  LETTER_SPACING_H1: '4px',
  //H2
  FONT_SIZE_H2: '32px',
  LINE_HEIGHT_H2: '38px',
  LETTER_SPACING_H2: '1.92px',
  //H3
  FONT_SIZE_H3: '25px',
  LINE_HEIGHT_H3: '30px',
  LETTER_SPACING_H3: '1.5px',
  //H4
  FONT_SIZE_H4: '14px',
  LINE_HEIGHT_H4: '28px',
  LETTER_SPACING_H4: '1.4',
  //H5
  FONT_SIZE_H5: '16px',
  LINE_HEIGHT_H5: '13px',
  LETTER_SPACING_H5: '0.13px',
  //P
  FONT_SIZE_P: '16px',
  LINE_HEIGHT_P: '28px',
  LETTER_SPACING_P: '0.32px',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '56px',
    LINE_HEIGHT_H1: '64px',
    LETTER_SPACING_H1: '5.6px',
    //H2
    FONT_SIZE_H2: '40px',
    LINE_HEIGHT_H2: '56px',
    LETTER_SPACING_H2: '2.4px',
    //H3
    FONT_SIZE_H3: '30px',
    LINE_HEIGHT_H3: '38px',
    LETTER_SPACING_H3: '1.8px',
    //H4
    FONT_SIZE_H4: '15px',
    LINE_HEIGHT_H4: '26px',
    LETTER_SPACING_H4: '1.5px',
    //H5
    FONT_SIZE_H5: '13px',
    LINE_HEIGHT_H5: '16px',
    LETTER_SPACING_H5: '0.13px',
    //P
    FONT_SIZE_P: '17px',
    LINE_HEIGHT_P: '30px',
    LETTER_SPACING_P: '0.34px'
  },
  FONT_FACES: ['AbrilFatfaceRegular', 'LatoBold', 'LatoRegular']
};